import { AlertTriangleIcon } from 'assets/icons';
import { classnames } from 'helpers/utils';
import styles from './warning-reaching-clips-limit.module.scss';

type WarningReachingClipsLimitProps = {
  maxQuestionsPerVault: number;
  allClipsCount: number;
};

const WarningReachingClipsLimit: React.FC<WarningReachingClipsLimitProps> = ({
  maxQuestionsPerVault,
  allClipsCount,
}) => {
  const limitReached = allClipsCount === maxQuestionsPerVault;

  return (
    <div className={classnames(styles.warningClipLimitContainer)}>
      <div className={styles.leftSection}>
        <div
          className={classnames(styles.warningIcon, {
            [styles.redColor]: limitReached,
          })}
        >
          <AlertTriangleIcon />
        </div>
        <div className="text__body__regular__small__white">
          {limitReached
            ? 'Vault’s clip limit reached'
            : 'Reaching vault’s clip limit'}
        </div>
      </div>
      <div
        className={classnames(
          styles.rightSection,
          { [styles.redBackground]: limitReached },
          'text__body__regular__small__white',
        )}
      >
        <span>
          {allClipsCount}/{maxQuestionsPerVault}
        </span>
        <span>recorded</span>
      </div>
    </div>
  );
};

export { WarningReachingClipsLimit };
